<svg
  width="15"
  height="15"
  viewBox="0 0 15 15"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$restProps.class}
>
  <path
    id="Vector"
    d="M0.7 14.125H1.675L11.95 3.85L10.975 2.875L0.7 13.15V14.125ZM13.45 3.35L11.475 1.375L12.625 0.225C12.775 0.075 12.95 0 13.15 0C13.35 0 13.525 0.075 13.675 0.225L14.6 1.15C14.75 1.3 14.825 1.475 14.825 1.675C14.825 1.875 14.75 2.05 14.6 2.2L13.45 3.35ZM12.95 3.85L1.975 14.825H0V12.85L10.975 1.875L12.95 3.85ZM11.45 3.35L10.975 2.875L11.95 3.85L11.45 3.35Z"
    fill="white"
  />
</svg>
